import * as types from "./actionTypes";
import { AppThunk } from "./AppThunk";

export function updateCanLeave(canLeave: boolean): AppThunk {
    return function (dispatch, getState) {
        dispatch(canLeaveUpdated(canLeave));
    };
}

function canLeaveUpdated(canLeave: boolean) {
    return {
        type: types.CAN_LEAVE_UPDATED as typeof types.CAN_LEAVE_UPDATED,
        canLeave,
    };
}

export type ExitActions = ReturnType<typeof canLeaveUpdated>;
